// extracted by mini-css-extract-plugin
export default {"form":"Search_form__kU-nN","control":"Search_control__-eXt5","isModal":"Search_isModal__KOoXM","categories":"Search_categories__V80n+"};